// extracted by mini-css-extract-plugin
export default {"ComingSoonLabel":"ComingSoonLabel_ComingSoonLabel__XRVhp"};